module.exports = __webpack_public_path__ + "img/amilcarcorpeno.50c28103.jpg";